import React, { Component } from 'react';
import generateRandomID from 'uuid/v4';
import PropTypes from 'prop-types';
import { message, Modal, Upload } from 'antd';
import {
  InboxOutlined,
  LoadingOutlined,
  PlayCircleOutlined,
  PaperClipOutlined,
} from '@ant-design/icons';
import * as firebase from 'firebase';
import { saveAs } from 'file-saver';

const { confirm } = Modal;
const { Dragger } = Upload;
const generateRandomFilename = () => generateRandomID();

function extractExtension(filename) {
  const ext = /(?:\.([^.]+))?$/.exec(filename);
  if (ext != null && ext[0] != null) {
    return ext[0];
  }
  return '';
}

class FileUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      previewVisible: false,
      previewImage: '',
    };
  }

  componentDidMount() {
    const { getDraggerValue } = this.props;
    const draggerValues = getDraggerValue();
    if (draggerValues) {
      
      this.setState({
        fileList: draggerValues,
      });
    }
  }

  componentDidUpdate = prevState => {
    const { fileListData, handleFormValue } = this.props;
    if (fileListData !== prevState.fileListData) {
      if (fileListData) {
        
        const list = fileListData;
        const updatedList = list.map(file => {
          return {
            ...file,
            status: 'done',
            saved: true,
          };
        });
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          fileList: updatedList,
        });
        handleFormValue(updatedList);
      } else {
        
      }
    }
  };

  // Cancel all running uploads before unmount
  componentWillUnmount() {
    this.cancelRunningUploads();
  }

  uploadTasks = [];

  handleUploadError = error => {
    message.error('Audio could not be uploaded');
    console.error('handleuploadError:', error);
  };

  handleUploadSuccess = () => {
    message.success('Audio uploaded successfully');
    
  };

  cancelRunningUploads() {
    while (this.uploadTasks.length > 0) {
      const task = this.uploadTasks.pop();
      if (task.snapshot.state === 'running') {
        task.cancel();
      }
    }
  }

  // Remove a specific task from the uploadTasks
  removeTask(task) {
    for (let i = 0; i < this.uploadTasks.length; i += 1) {
      if (this.uploadTasks[i] === task) {
        this.uploadTasks.splice(i, 1);
        return;
      }
    }
  }

  handlePreview = async file => {
    
    if (!file.url && !file.preview) {
      // eslint-disable-next-line no-param-reassign
      // file.preview =  file.originFileObj;
      this.setState({
        previewImage: file.url || file.preview,
        previewVisible: false,
      });
    } else {
      this.setState({
        previewImage: file.url || file.preview,
        previewVisible: true,
      });
    }
  };

  handleCancel = () => this.setState({ previewVisible: false });

  handleChange = ({ fileList }) => {
    
    this.setState({ fileList });
    const itemList = [];
    fileList
      .filter(fileIt => fileIt.status === 'done' && fileIt.saved !== true)
      .forEach(fileIt => {
        const item = {
          uid: fileIt.uid,
          name: fileIt.name,
        };
        const { storageFolder } = this.props;
        firebase
          .storage()
          .ref(storageFolder)
          .child(fileIt.name)
          .getDownloadURL()
          .then(url => {
            item.url = url;
          });
        itemList.push(item);
      });
    fileList
      .filter(fileIt => fileIt.saved)
      .forEach(fileIt => {
        const item = {
          uid: fileIt.uid,
          name: fileIt.name,
          url: fileIt.url,
        };
        itemList.push(item);
      });
    const { handleFormValue } = this.props;
    handleFormValue(itemList);
  };

  removeFileFromFileList = file => {
    const { fileList } = this.state;
    const newFileList = fileList.filter(
      it => it.uid !== file.uid && it.name !== file.name,
    );
    this.setState(
      {
        fileList: newFileList,
      },
      () => {
        this.handleChange(this.state);
      },
    );
  };

  openRemovePopup = (file, storageFolder, callback) => {
    confirm({
      title: 'Are you sure you want to delete?',
      content: 'Please remember to save changes',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        firebase
          .storage()
          .ref(storageFolder)
          .child(file.name)
          .delete()
          .then(() => {
            message.info('Audio Deleted');
            callback(file);
            return true;
          })
          .catch(error => {
            
            message.error('Audio could not be deleted');
            return false;
          });
      },
      onCancel() {},
    });
  };

  openRemovePopupAndSave = (file, storageFolder, callback) => {
    const { submit } = this.props;
    confirm({
      title: 'Are you sure you want to delete?',
      content: 'Please remember to save changes',
      okText: 'Yes & Save',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        firebase
          .storage()
          .ref(storageFolder)
          .child(file.name)
          .delete()
          .then(() => {
            message.info('Audio Deleted');
            return true;
          })
          .catch(error => {
            
            message.error('Audio could not be deleted');
            return false;
          })
          .finally(() => {
            callback(file);
            submit();
          });
      },
      onCancel() {},
    });
  };

  handleRemove = file => {
    
    const { storageFolder } = this.props;
    if (file.saved) {
      this.openRemovePopupAndSave(
        file,
        storageFolder,
        this.removeFileFromFileList,
      );
    } else {
      this.openRemovePopup(file, storageFolder, this.removeFileFromFileList);
    }
    return false;
  };

  // eslint-disable-next-line no-unused-vars
  startUpload = ({ onError, onSuccess, file }) => {
    
    const {
      onUploadStart,
      onProgress,
      // eslint-disable-next-line no-unused-vars
      onUploadError,
      // eslint-disable-next-line no-unused-vars
      onUploadSuccess,
      storageRef,
      metadata,
      randomizeFilename,
      filename,
    } = this.props;

    let filenameToUse;
    if (filename) {
      filenameToUse =
        typeof filename === 'function' ? filename(file) : filename;
    } else {
      filenameToUse = randomizeFilename ? generateRandomFilename() : file.name;
    }

    // Ensure there is an extension in the filename
    if (!extractExtension(filenameToUse)) {
      filenameToUse += extractExtension(file.name);
    }

    Promise.resolve(file).then(newFile => {
      const meta = {
        ...metadata,
        cacheControl: 'public, max-age=86400',
      };
      const task = storageRef.child(filenameToUse).put(newFile, meta);

      if (onUploadStart) {
        onUploadStart(newFile, task);
      }

      task.on(
        'state_changed',
        snapshot =>
          onProgress &&
          onProgress(
            Math.round((100 * snapshot.bytesTransferred) / snapshot.totalBytes),
            task,
          ),
        error => this.handleUploadError && this.handleUploadError(error, task),
        () => {
          this.removeTask(task);
          // 
          onSuccess(null, task);
          return (
            this.handleUploadSuccess &&
            this.handleUploadSuccess(task.snapshot.metadata.name, task)
          );
        },
      );
      this.uploadTasks.push(task);
    });
  };

  handleIconRender = file => {
    let icon = '';
    if (file.status === 'uploading') {
      icon = <LoadingOutlined />;
    } else if (file.url) {
      icon = <PlayCircleOutlined onClick={() => this.handlePreview(file)} />;
    } else {
      icon = <PaperClipOutlined />;
    }
    return icon;
  };

  handleDownload = file => {
    
    if (file.url) {
      saveAs(file.url, file.name);
    }
    if (file.originFileObj) {
      saveAs(file.originFileObj, file.name);
    }
  };

  render() {
    const { fileList } = this.state;
    const { previewVisible, previewImage } = this.state;
    const { disabledAdd, maxCount, accept, acceptedMessage } = this.props;
    return (
      <div>
        <Dragger
          name="file"
          onPreview={this.handlePreview}
          fileList={fileList}
          onChange={this.handleChange}
          customRequest={this.startUpload}
          onRemove={this.handleRemove}
          onDownload={this.handleDownload}
          disabled={disabledAdd}
          showUploadList={{
            showPreviewIcon: true,
            showDownloadIcon: true,
            showRemoveIcon: !disabledAdd,
          }}
          iconRender={this.handleIconRender}
          accept={accept}
          maxCount={maxCount}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag file to this area to upload
          </p>
          <p className="ant-upload-hint">{acceptedMessage}</p>
        </Dragger>
        <Modal
          visible={previewVisible}
          footer={null}
          onCancel={this.handleCancel}
          closable={false}
          destroyOnClose
        >
          <audio controls autoPlay style={{ width: '100%' }}>
            <source src={previewImage} />
            <track
              src="captions_en.vtt"
              kind="captions"
              label="english_captions"
            />
          </audio>
        </Modal>
      </div>
    );
  }
}

FileUploader.propTypes = {
  storageRef: PropTypes.object,
  onUploadStart: PropTypes.func,
  onProgress: PropTypes.func,
  onUploadSuccess: PropTypes.func,
  onUploadError: PropTypes.func,
  filename: PropTypes.string,
  metadata: PropTypes.object,
  randomizeFilename: PropTypes.bool,
  handleFormValue: PropTypes.func,
  getDraggerValue: PropTypes.func,
  fileListData: PropTypes.object,
  storageFolder: PropTypes.string,
  disabledAdd: PropTypes.bool,
  maxCount: PropTypes.number,
  accept: PropTypes.string,
  acceptedMessage: PropTypes.string,
  submit: PropTypes.func,
};

export default FileUploader;
